import napStyles from './../nap.json'

export default {
  color: napStyles.colors.PrimaryBlack,
  borderColor: napStyles.colors.SecondaryGreySteel,
  hover: {
    borderColor: napStyles.colors.SecondaryGreySky
  },
  active: {
    borderColor: napStyles.colors.PrimaryBlack
  }
}
